/**
 * Default time formats to create time

 * @readonly
 * @constant
 */

export default {
  CREATE: 'DD.MM.YYYY HH:mm:ss',
};
